import { JsonObject, JsonProperty } from "json2typescript";

import * as GQL from "../util/graphql-tags";
import { Order } from './order.enum';
import { json2ts } from "../util/json-2ts";
import { Timestamp } from "../timestamp.model";
import { ProcessingRun } from "./processing-run.model";

@JsonObject("ProcessingEvent")
export class ProcessingEvent {

  static equals(a: ProcessingEvent, b: ProcessingEvent): boolean {

    if (null == a || null == b) {
      return false;
    }

    if (a.code !== b.code) {
      return false;
    }

    if (!ProcessingRun.equals(a.run, b.run)) {
      return false
    }

    return Timestamp.equals(a.timestamp, b.timestamp);

  }

  @JsonProperty("code", String, false)
  public code: string = null;

  @JsonProperty("Timestamp", Timestamp, false)
  public timestamp: Timestamp = null;

  @JsonProperty("Run", ProcessingRun, true)
  public run?: ProcessingRun = null;

}
